import { createAsyncThunk } from '@reduxjs/toolkit'
import { Product, Role, RoleFormModel } from './typings'
import { ServiceConfig } from '../services/config'
import { APIError, APIReject, get, post, put, remove } from '../services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.role.role}`

export const getRoles = createAsyncThunk<
  Role[],
  boolean,
  { rejectValue: APIError }
>('roles/all', async (includePermissions, thunkApi) => {
  const response = await get(
    `${baseUrl}?includePermissions=${includePermissions}`,
  )
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getProductPermissions = createAsyncThunk<
  Product[],
  void,
  { rejectValue: APIError }
>('roles/products', async (_, thunkApi) => {
  const response = await get(`${baseUrl}/GetAllPermissions`)
  if (response.ok) {
    const result: any[] = await response.json()
    const products: Product[] = result.map((p) => ({
      permissions: p.permisssions,
      ...p,
    }))
    return products
  }
  return thunkApi.rejectWithValue(await response.json())
})

export const createRole = createAsyncThunk<
  Role,
  RoleFormModel,
  { rejectValue: APIReject }
>('roles/create', async (model, thunkApi) => {
  const response = await post(baseUrl, model)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const readRole = createAsyncThunk<
  RoleFormModel,
  number,
  { rejectValue: APIError }
>('roles/read', async (id, thunkApi) => {
  const response = await get(`${baseUrl}/${id}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const updateRole = createAsyncThunk<
  void,
  RoleFormModel,
  { rejectValue: APIReject }
>('roles/update', async (model, thunkApi) => {
  const response = await put(baseUrl, model)
  if (response.ok) thunkApi.dispatch(getRoles(true))
  else return thunkApi.rejectWithValue(await response.json())
})

export const deleteRole = createAsyncThunk<
  number,
  number,
  { rejectValue: APIError }
>('roles/delete', async (id, thunkApi) => {
  const response = await remove(`${baseUrl}/${id}`)
  if (response.ok) return id
  return thunkApi.rejectWithValue(await response.json())
})
